import type { View } from "@-/com.npmjs.react-native";
import {
  measure,
  useSharedValue,
  type AnimatedRef,
  type SharedValue,
} from "@-/com.npmjs.react-native-reanimated";
import { useCallback } from "react";
import type { RegisterLearnFlashcardHorizontalGestureBlocker } from "#learn-card-horizontal-gesture-blockers-context";

export type LearnFlashcardHorizontalGestureBlockerViews = SharedValue<readonly AnimatedRef<View>[]>;

/**
 * The deck side of `LearnFlashcardHorizontalGestureBlocker`: the registered views, for the card pan to
 * test each touch-down against, and the register function to provide through
 * `LearnFlashcardHorizontalGestureBlockersContext`.
 */
export function useLearnFlashcardHorizontalGestureBlockers() {
  const views = useSharedValue<readonly AnimatedRef<View>[]>([]);
  const register = useCallback<RegisterLearnFlashcardHorizontalGestureBlocker>(
    (view) => {
      views.set([...views.get(), view]);
      return () => {
        views.set(views.get().filter((registered) => registered !== view));
      };
    },
    [views],
  );
  return { register, views };
}

/** Whether a touch at window point (`x`, `y`) lands inside one of the registered views. */
export function isInLearnFlashcardHorizontalGestureBlocker(
  views: LearnFlashcardHorizontalGestureBlockerViews,
  x: number,
  y: number,
) {
  "worklet";
  for (const view of views.get()) {
    const frame = measure(view);
    if (
      frame !== null &&
      x >= frame.pageX &&
      x <= frame.pageX + frame.width &&
      y >= frame.pageY &&
      y <= frame.pageY + frame.height
    ) {
      return true;
    }
  }
  return false;
}
